import { PatientGroupEffect } from '@dreryk/egabinet-patient-frontend-api';

import { PredefinedPatientGroupsUpdateFormBean } from './PredefinedPatientGroupsUpdateForm.types';
import { FIELD_TO_EFFECT } from './PredefinedPatientGroupsUpdateForm.constants';

export const mapFormBeanToPatientGroupEffects = (bean: PredefinedPatientGroupsUpdateFormBean): PatientGroupEffect[] =>
   Object.entries(FIELD_TO_EFFECT)
      .filter(([field]) => bean[field as keyof PredefinedPatientGroupsUpdateFormBean])
      .map(([, effect]) => effect);

export const mapPatientGroupEffectsToFormBean = (
   effects: PatientGroupEffect[]
) => (): PredefinedPatientGroupsUpdateFormBean =>
   Object.fromEntries(
      Object.entries(FIELD_TO_EFFECT).map(([field, effect]) => [field, effects.includes(effect)])
   ) as PredefinedPatientGroupsUpdateFormBean;
